@if (formField(); as field) {
  <div class="flex flex-col gap-2">
    @if (field.label) {
      <app-label [required]="field.required!!">{{ field.label }}</app-label>
    }
    <ng-template customForm />
  </div>
}
